import React, { useState } from 'react';
import { requestEmailVerify, confirmEmail } from '../api/emailVerify';

const overlayStyle = {
    position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: 16
};
const cardStyle = {
    background: '#fff', borderRadius: 16, padding: 28, maxWidth: 420, width: '100%',
    boxShadow: '0 20px 60px rgba(0,0,0,0.25)'
};
const inputStyle = {
    width: '100%', border: '1px solid #e2e8f0', borderRadius: 10, padding: '11px 12px',
    fontSize: 15, boxSizing: 'border-box', marginTop: 6
};
const primaryBtn = {
    width: '100%', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 10,
    padding: '12px 16px', fontWeight: 600, cursor: 'pointer', marginTop: 14, fontSize: 15
};
const skipBtn = {
    width: '100%', background: 'transparent', color: '#64748b', border: 'none',
    padding: '10px 16px', cursor: 'pointer', marginTop: 6, fontSize: 14
};

/**
 * "Почти обязательный" email после первого входа. Не блокирует работу (есть "Не сейчас"),
 * но пока EmailVerified=false на сервере — появляется заново при каждом следующем логине
 * (см. onDismiss в App.jsx — просто скрывает до конца текущей сессии, не насовсем).
 */
export default function EmailVerifyModal({ initialEmail, onVerified, onDismiss }) {
    const [step, setStep] = useState('email'); // 'email' | 'code'
    const [email, setEmail] = useState(initialEmail || '');
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    async function handleSendCode(e) {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await requestEmailVerify(email.trim());
            setStep('code');
        } catch (err) {
            setError(err.response?.data?.message || 'Не удалось отправить код');
        }
        setLoading(false);
    }

    async function handleConfirm(e) {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await confirmEmail(email.trim(), code.trim());
            localStorage.setItem('emailVerified', 'true');
            localStorage.setItem('userEmail', email.trim());
            onVerified?.();
        } catch (err) {
            setError(err.response?.data?.message || 'Не удалось подтвердить код');
        }
        setLoading(false);
    }

    return (
        <div style={overlayStyle}>
            <div style={cardStyle}>
                {step === 'email' ? (
                    <form onSubmit={handleSendCode}>
                        <h3 style={{ margin: '0 0 8px' }}>Добавьте email</h3>
                        <p style={{ margin: '0 0 4px', color: '#64748b', fontSize: 14, lineHeight: 1.5 }}>
                            Код придёт мгновенно, без задержек связи с оператором. Пригодится и для
                            восстановления доступа, если потеряете телефон.
                        </p>
                        <label style={{ display: 'block', marginTop: 16 }}>
                            <span style={{ fontSize: 13, color: '#475569' }}>Email</span>
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                placeholder="you@example.com"
                                style={inputStyle}
                                autoFocus
                            />
                        </label>
                        {error && <p style={{ color: '#dc2626', fontSize: 13, marginTop: 8 }}>{error}</p>}
                        <button type="submit" style={primaryBtn} disabled={loading}>
                            {loading ? 'Отправляю…' : 'Отправить код'}
                        </button>
                        <button type="button" style={skipBtn} onClick={onDismiss}>
                            Не сейчас
                        </button>
                    </form>
                ) : (
                    <form onSubmit={handleConfirm}>
                        <h3 style={{ margin: '0 0 8px' }}>Введите код</h3>
                        <p style={{ margin: '0 0 4px', color: '#64748b', fontSize: 14 }}>
                            Отправили на {email}
                        </p>
                        <label style={{ display: 'block', marginTop: 16 }}>
                            <span style={{ fontSize: 13, color: '#475569' }}>Код из письма</span>
                            <input
                                type="text"
                                inputMode="numeric"
                                required
                                value={code}
                                onChange={e => setCode(e.target.value)}
                                placeholder="000000"
                                style={inputStyle}
                                autoFocus
                            />
                        </label>
                        {error && <p style={{ color: '#dc2626', fontSize: 13, marginTop: 8 }}>{error}</p>}
                        <button type="submit" style={primaryBtn} disabled={loading}>
                            {loading ? 'Проверяю…' : 'Подтвердить'}
                        </button>
                        <button type="button" style={skipBtn} onClick={() => setStep('email')}>
                            Изменить адрес
                        </button>
                        <button type="button" style={skipBtn} onClick={onDismiss}>
                            Не сейчас
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}
